<template>
  <div>
    <div v-if="typeof data.profile === 'string' && data.profile.length > 0">
      <img
        :alt="data.name.fullName"
        :src="getImgResourceFile()"
        class="mgr-16 user-name-profile"
        :class="[size ? size : 's', className]"
      />
    </div>
    <div
      v-else-if="
        isBlocked || (!data.profile && typeof data.profile !== 'string')
      "
    >
      <div>
        <img
          :alt="'isBlocked'"
          :src="'/images/avatar_image.png'"
          class="mgr-16 user-name-profile"
          :class="[size ? size : 's', className]"
        />
      </div>
    </div>
    <div v-else>
      <div v-if="data.status && checkDeactivateUser(data)">
        <div
          v-if="firstCharOfMemberName(data.name)"
          :style="`background-color: ${backgroundColor}`"
          class="mgr-16 user-name-profile"
          :class="[size ? size : 's', className]"
        >
          {{ firstCharOfMemberName(data.name) }}
        </div>
        <div v-else>
          <img
            :alt="'isBlocked'"
            :src="'/images/avatar_image.png'"
            class="mgr-16 user-name-profile"
            :class="[size ? size : 's', className]"
          />
        </div>
      </div>
      <div v-else>
        <img
          v-if="isImgProfileComputed"
          :alt="data.name.fullName"
          :src="getImgResourceFile()"
          class="mgr-16 user-name-profile"
          :class="[size ? size : 's', className]"
        />
        <div
          v-else
          :style="`background-color: ${backgroundColor}`"
          class="mgr-16 user-name-profile"
          :class="[size ? size : 's', className]"
        >
          {{ firstCharOfMemberName(data.name) }}
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
/**
 * 유저프로필사진 컴포넌트, 유저 상태에 따라 분기
 * @author jaehyub.lee@emcast.com
 * @size { xs, s, m, l, xl, xxl, xxxl }
 */
import { userMixin } from "@/mixins/user";
import { storageConstants } from "@/utils/enum/StorageConstants";
import {
  getBackgroundColor,
  randomColor,
} from "@/utils/getBackgroundColorUtil.js";

export default {
  name: "UserImgProfile",
  mixins: [userMixin],
  props: ["data", "className", "size", "allData", "profileOnly"],
  data() {
    return {
      brandName: localStorage.getItem(storageConstants.brandName),
      bgColorOfName: localStorage.getItem(storageConstants.bgColors),
      backgroundColor: null,
      isBlocked: false,
    };
  },

  watch: {
    allData: function (value) {
      this.isBlocked = value.isBlocked;
    },
  },

  mounted() {
    if (this.allData) {
      this.isBlocked = this.allData.isBlocked;
    }

    this.setBackgroundColor(this.data);
  },

  computed: {
    isImgProfileComputed() {
      if (!this.data || !this.data.profile) return false;
      if (typeof this.data.profile === "string" && this.data.profile.length > 0) return true;
      // file이 아니라 resourceUri를 직접 체크
      return (
        this.data.profile.resourceUri &&
        this.data.profile.resourceUri.length > 0
      );
    },
  },

  methods: {
    firstCharOfMemberName(name) {
      if (!name) return false;
      if (typeof name === "string") return name.charAt(0);
      if (name.first) {
        let fullName = name.fullName ? name.fullName : "";
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },
    getImgResourceFile() {
      if (typeof this.data.profile === "string" && this.data.profile.length > 0) {
        return this.data.profile;
      }
      if (this.data.profile.resourceUri && this.data.profile.resourceUri.length > 0) {
        return this.data.profile.resourceUri;
      }
      return null;
    },
    setBackgroundColor(user) {
      const color = getBackgroundColor(user);
      this.backgroundColor = color || randomColor;
    },
  },
};
</script>
  
<style scoped>
.profile-img-default {
  border-radius: 50%;
}

.main-l {
  min-width: 130px !important;
  width: 130px !important;
  height: 130px !important;
  font-size: 50px !important;
  font-weight: 500 !important;
  color: var(--DocumentWhite) !important;
}

.xxxl {
  min-width: 116px !important;
  width: 116px !important;
  height: 116px !important;
  font-size: 44px !important;
}

.xxl {
  min-width: 108px !important;
  width: 108px !important;
  height: 108px !important;
  font-size: 44px !important;
}

.xl {
  min-width: 64px !important;
  width: 64px !important;
  height: 64px !important;
  font-size: 28px !important;
}

.l {
  min-width: 62px !important;
  width: 62px !important;
  height: 62px !important;
  font-size: 28px !important;
}

.m {
  min-width: 52px !important;
  width: 52px !important;
  height: 52px !important;
  font-size: 22px !important;
}

.s {
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  font-size: 18px !important;
}

.xs {
  min-width: 28px !important;
  width: 28px !important;
  height: 28px !important;
  font-size: 13px !important;
}

.mgr-0 {
  margin-right: 0 !important;
}
</style>